var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNetwork({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3155 45.9877L25.3119 14.5929L49.0024 36.3494L18.3155 45.9877Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.44736
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9708 49.3115C9.89368 45.8821 11.8006 42.2289 15.2299 41.1518C18.6593 40.0747 22.3125 41.9815 23.3896 45.4109C24.4667 48.8402 22.5598 52.4935 19.1305 53.5706C15.7011 54.6477 12.0479 52.7408 10.9708 49.3115Z",
    fill: "#3B82C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0265 15.2294C17.9493 11.8001 19.8562 8.14685 23.2856 7.06974C26.7149 5.99263 30.3681 7.8995 31.4453 11.3289C32.5224 14.7582 30.6155 18.4114 27.1861 19.4885C23.7568 20.5656 20.1036 18.6588 19.0265 15.2294Z",
    fill: "#2B6299"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3458 38.8283C43.2687 35.3989 45.1756 31.7457 48.6049 30.6686C52.0343 29.5915 55.6875 31.4984 56.7646 34.9277C57.8417 38.3571 55.9348 42.0103 52.5055 43.0874C49.0761 44.1645 45.4229 42.2577 44.3458 38.8283Z",
    fill: "#8CBFFF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.ab240d68.svg";
export { ForwardRef as ReactComponent };